'use strict';

var Sugar = require('sugar-core'),
    reverseString = require('./internal/reverseString');

Sugar.String.defineInstance({

  'reverse': function(str) {
    return reverseString(str);
  }

});

module.exports = Sugar.String.reverse;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/string/reverse.js
// module id = 925
// module chunks = 0